import React from 'react';

import { Title, Paragraph, Box, constants, Stack } from '@thecb/components';
import { WelcomePinpad } from '../images/WelcomePinpad';

const WelcomeHeader = ({ actionText }) => {
  return (
    <Box
      extraStyles="background: linear-gradient(97.79deg, #D9D9FB -0.76%, #CDEBF7 100%)"
      padding="48px 48px 48px 32px"
      borderRadius="8px 8px 0 0"
    >
      <Stack direction="row" childGap="0" justify="space-between">
        <Box
          padding="0"
          extraStyles={`
            display: flex;
            flex-direction: column;
            justify-content: center;
          `}
        >
          <Title
            weight={constants.fontWeights.FONT_WEIGHT_BOLD}
            variant="large"
            color={constants.colors.CHARADE_GREY}
            role="heading"
          >
            Welcome to Cashiering
          </Title>
          <Box padding="2px" />
          <Paragraph
            variant="pL"
            weight="normal"
            color={constants.colors.CHARADE_GREY}
            role="heading"
          >
            {actionText}
          </Paragraph>
        </Box>
        <WelcomePinpad />
      </Stack>
    </Box>
  );
};

export default WelcomeHeader;
